module.exports = __webpack_public_path__ + "static/media/events_11.c8ba9141.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/JPEG/events_11.jpg
// module id = 5929
// module chunks = 0